import "core-js/modules/es6.object.to-string.js";
export function bindAll(context, arrFunc) {
  arrFunc.forEach(function (item) {
    context[item] = context[item].bind(context);
  });
}
export function type(obj) {
  var toString = Object.prototype.toString;
  return toString.call(obj);
}
export function isNumber(obj) {
  return type(obj) == '[object Number]';
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-drawer/src/common/index.js